if (!customElements.get('discount-products')) {
  class DiscountProducts extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const is_mobile = this.isMobile();
      const $tips = document.querySelector('.discount-products-mobile-tips');
      this.drawerContent = document.querySelector('.drawer__content');

      if (!$tips) {
        this.render();
        this.bindEvent();
      }
    }

    isMobile() {
      const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      return reg.test(navigator.userAgent);
    }

    render() {
      const remain = this.querySelector('.cart-recommendations').getAttribute('data-remain');
      const tips_1 = this.querySelector('.cart-recommendations').getAttribute('data-tips-1');
      const tips_2 = this.querySelector('.cart-recommendations').getAttribute('data-tips-2');

      var existingElement = document.querySelector('.drawer--cart .drawer__header');
       
      var newElement = document.createElement('div');

      newElement.classList.add('discount-products-mobile-tips')
      
      newElement.innerHTML = `
        <div class="tips-content">
          <div class="tips-1">${ tips_1 }</div>
          <div class="tips-2">${ tips_2 }</div>
        </div>
        <button class="get-now-btn btn btn--primary" type="button">Get Now</button>
      `;
       
      existingElement.insertAdjacentElement('afterend', newElement);

      this.getNowBtn = document.querySelector('.get-now-btn');
    }

    bindEvent() {
      this.getNowBtn.addEventListener('click', this.showProductList.bind(this, this.getNowBtn));
    }

    showProductList($target) {
      this.drawerContent.scrollTop = this.drawerContent.scrollHeight
    }
  }

  customElements.define('discount-products', DiscountProducts);
}